import { ProjectsService } from "@/common/api.service";
import { FETCH_CALENDAR_PLAN, NORMALIZE_CALENDAR_PLAN } from "./actions.type";
import {applyToSubtree, getSubtreeSourceIds} from "@/utils/plan";

const state = {
  calendarItems: {
    PLAN: [],
    YEAR_SETTING: {
      yearEnd: 0,
      yearStart: 0
    },
    httpCode: 200
  }
};

const getters = {
  calendarItems() {
    return state.calendarItems;
  }
};

const actions = {
  [FETCH_CALENDAR_PLAN]({ state }, id) {
    ProjectsService.loadPlan(id)
      .then(({ data }) => {
        let years = [];
        for (
          let i = data.YEAR_SETTING.yearStart;
          i <= data.YEAR_SETTING.yearEnd;
          i++
        ) {
          years.push(i);
        }

        function pushYears(items) {
          if (items && items.length > 0) {
            items.forEach(function(item) {
              item.IS_HIDE = false;
              if (item.YEAR_DATA === null) {
                item.YEAR_DATA = [];
                years.forEach(function(v) {
                  item.YEAR_DATA.push({
                    UF_PLAN_ROW_ID: item.ID,
                    UF_KV1: 0,
                    UF_KV2: 0,
                    UF_KV3: 0,
                    UF_KV4: 0,
                    UF_YEAR: v
                  });
                }, this);
              }
              pushYears(item.CHILD);
            }, this);
          }
        }
        if (data.PLAN) {
          pushYears(data.PLAN);
        }
        state.calendarItems = data;
      })
      .catch(error => {
        if (error.message.includes("HttpCode:403")) {
          state.calendarItems.httpCode = 403;
        }
        throw new Error(error);
      });
  },
  [NORMALIZE_CALENDAR_PLAN]({ state }) {
    // Правильно расставим источники, основываясь на иерархии этапов
    for (const item of state.calendarItems.PLAN) {
      applyToSubtree(item, (item) => {
        item.UF_ISTOCHNIK_ID = getSubtreeSourceIds(item);
      });
    }
  },
};

export default {
  state,
  getters,
  actions
};
